module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submiting
    },
    on: {
      "click": _vm.upSubmit
    }
  }, [_vm._v("开始上传")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.upload.clearFiles()
      }
    }
  }, [_vm._v("清空列表")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "选择分类"
    },
    model: {
      value: (_vm.fenlei),
      callback: function($$v) {
        _vm.fenlei = $$v
      },
      expression: "fenlei"
    }
  }, _vm._l((_vm.fenleis), function(fl) {
    return _c('el-option', {
      key: 'fl1-' + fl.Id,
      attrs: {
        "label": fl.Name,
        "value": fl.Id + ''
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px",
      "margin-top": "10px",
      "margin-left": "10px"
    },
    attrs: {
      "auto-complete": "off",
      "placeholder": "统一金额"
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "light",
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("如果有用户投诉文件有密码等"), _c('span', {
    staticStyle: {
      "color": "#e20101"
    }
  }, [_vm._v("无法使用的情况")]), _vm._v("，经客服核实后"), _c('br'), _vm._v("\n          会发起全额退款，包括用户下载产生的流量费也"), _c('span', {
    staticStyle: {
      "color": "#e20101"
    }
  }, [_vm._v("由该作者承担")])])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://mp.weixin.qq.com/s/NhYs51XBuWYvy9uRDXRBkw",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "10px",
      "width": "100%",
      "height": "35px"
    },
    attrs: {
      "src": "//static.jazpan.com/img/scznx.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xtips"
  }, [_vm._v("\n          小提示：请不要上传有密码等有限制的文件\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "xtips"
  }, [_c('a', {
    attrs: {
      "href": "https://jazpan.com/cmt/t/26",
      "target": "_blank"
    }
  }, [_vm._v("Windows App 可以上传超过2G的文件")])])])])], 1), _vm._v(" "), _c('div', [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "upfile",
      "drag": "",
      "multiple": "",
      "auto-upload": false,
      "action": _vm.uploadActUrl,
      "before-upload": _vm.handleBeforeUpload,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    },
    on: {
      "update:action": function($event) {
        _vm.uploadActUrl = $event
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击选择文件")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  })])], 1), _vm._v(" "), _c('proEdit', {
    ref: "proEdit"
  }), _vm._v(" "), _c('ChongVip', {
    ref: "chongVipDlg",
    on: {
      "submitOK": function($event) {
        return _vm.$refs.chongVipDlg.close()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24e307f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ruis/file/Upload.vue
// module id = 1156
// module chunks = 1